const PACKAGE_SIZE_PROPERTY: string = '$ps';

export const PRODUCTS = {
    packageSizeProperty: PACKAGE_SIZE_PROPERTY,
};
